import React, { useState, useEffect, useContext } from 'react';
// import PricingTable from '../components/PricingTable'
// import {ReactComponent as KomIcon} from '../../src/assets/gold_KOM.svg'
import {ReactComponent as TextractifyIcon} from '../../src/assets/images/textractifyIcon.svg'
import storage from "../utils/local_storage"
import { useNavigate } from 'react-router-dom';
import filler_image from '../assets/images/vidToSheet.jpeg'
import video_input from '../assets/images/video_input.png'
import cyber_charging from '../assets/images/cyber_charging.gif'
import data_output from '../assets/images/data_output.png'
import NumericalExample from '../assets/images/NumericalExample.png'
import RegionExample from '../assets/images/RegionExample.png'
import ScrollListExample from '../assets/images/ScrollListExample.png'
import PresentationExample from '../assets/images/PresentationExample.png'
import {ReactComponent as CurveArrowIcon} from '../assets/curve-arrow.svg'
import apiClient from '../utils/apiClient'; // Assume this is configured to work with your backend API
import { StateContext } from '../stateContext';
import { TableCellsIcon, PresentationChartLineIcon, ChatBubbleBottomCenterIcon, CircleStackIcon, LanguageIcon, DocumentChartBarIcon } from '@heroicons/react/24/outline'
import CREDIT_VALUE from '../utils/constants'
import { useUser } from '../utils/UserProvider'; // Adjust the import path as necessary
import { PlayCircle } from 'react-feather';
import { Helmet } from 'react-helmet';

function HomePage() {
  const {setToastData} = useContext(StateContext);
  // const token = localStorage.getItem('Token');
  const [demoData, setDemoData] = useState(null); // Track clicked boxes
  const [email, setEmail] = useState('');

  const navigate = useNavigate();
  const { profile, user, signOut, signIn } = useUser();

  // const handleDashboardButtonClick = () => {
  //   navigate('/dashboard'); // Replace '/path-to-navigate' with your route
  // };

  const DashboardButton = () => {
    return (
      <button className="btn btn-success text-lg" onClick={()=>navigate('/uploads')}>Go to Dashboard</button>
    )
  }

    const LogInButton = () => {
    return (
      <div>
        <button className="btn btn-success text-lg" onClick={()=>navigate('/login')}>Sign up for free</button>
      </div>
    )
  }

  useEffect(() => {
    downloadDemoData()
  }, []);

  const downloadDemoData = async () => {
    try {
      const response = await apiClient.get(`/getUploadDetails/demo`);
      setDemoData(response.data)
    } catch (error) {
      console.error('Error fetching upload details:', error);
    }
  };

  const validateEmail = (email) => {
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return regex.test(email);
}

  const handleEmailSubmit = async () => {
    // event.preventDefault();
    if (!validateEmail(email)) {
      setToastData({text:"Please submit a valid email", show:true})
      return
    }

    try {
      const response = await apiClient.post(`/emails`, { email });
      setToastData({text:"Thank you for connecting with Textractify", show:true})
      setEmail(''); // Clear the input after successful submission
    } catch (error) {
      console.error('Error submitting email:', error);
      alert('Error submitting email. Please try again later.');
    }
  };

  return (
    <div className="flex flex-col items-center justify-center space-y-8 m-4">
      <Helmet>
        <title>Textractify | Extract visible text from videos.</title>
        <meta name="description" content="OCR to extract data, subtitles, text from videos and photos." />
        <meta property="og:title" content="Textractify | Extract visible text from videos." />
        <meta property="og:description" content="OCR to extract data, subtitles, text from videos and photos." />
        <meta property="og:url" content={window.location.href} />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Textractify | Extract visible text from videos." />
        <meta name="twitter:description" content="OCR to extract data, subtitles, text from videos and photos." />
      </Helmet>
      {/* Row 1 */}
      <div className="flex flex-col lg:flex-row justify-center min-h-1/2 items-center mt-4 w-full">
        <div className="flex flex-col text-center m-4 w-full lg:w-1/2">
          <div className="flex flex-col items-center justify-center mx-auto pb-4">
            <TextractifyIcon width="75" height="75" className=" mr-4"/>
            <p className="text-4xl font-bold">Textractify</p>
          </div>
            <p className="text-2xl font-bold">Extract on-screen text from photos and videos in seconds.</p>
            <p className="text-md pb-4">  Textractify automatically scans your uploads for on-screen text and provides tools to export and organize the data.</p>
            {/* <p className="text-md font-semibold pb-4">Turn unstructured visuals into usable text.</p> */}
          <button className="btn btn-normal text-lg w-sm mx-auto my-4" onClick={() =>  navigate('/demo', { state: { demoData } })}>Try the demo</button>
        {user ? 
          <div className="flex flex-col justify-center items-center">
            <DashboardButton/>
          </div> : 
          <div className="flex flex-col justify-center items-center">
            <LogInButton/>
          </div>}
      {/* {token ? <DashboardButton/>:<SignupButton/>} */}
        </div>
        <div className="relative py-8 px-8 my-4 flex justify-center items-center w-full">
          <div className="flex items-center justify-center w-1/2 lg:w-3/5 px-0 lg:px-8 xl:px-10">
            <img 
              src={cyber_charging}
              alt="video input"
              className="flex-grow  transform translate-y-12 -rotate-6 rounded-lg z-0" 
            />
            <img 
              src={data_output} 
              alt="data output"
              className="flex-grow  transform rotate-6 rounded-lg z-1" 
            />
            <div className="absolute z-2 transform scale-x-[-1]" style={{ width: '30vw', maxWidth: '120px'}}>
              <CurveArrowIcon className="w-full h-auto" />
            </div>
          </div>
        </div>
      </div>
      <div className="divider"></div>
      <div className="container mx-auto px-4">
        <p className="text-2xl font-bold text-center pb-4">Text Extraction Modes</p>
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 bg-base-200 p-8 rounded-2xl">
          
          {/* Presentation */}
          <div
            onClick={()=>navigate('/blog/presentation-text-extraction')}
            className="cursor-pointer rounded-lg bg-white overflow-hidden shadow-lg transform transition-transform duration-200 hover:scale-105"
          >
            <img
              src={PresentationExample}
              alt="Presentation mode screenshot"
              className="w-full h-48 object-cover"
            />
            <div className="p-6">
              <h3 className="text-lg font-bold mb-2">Presentation</h3>
              <p className="text-sm mb-2 font-semibold">
                Readable lines and paragraphs from each frame.
              </p>
              <p className="text-sm">
                Best for decks, slides, or screenshots where you just want clean text.
              </p>
            </div>
          </div>

          {/* Numerical */}
          <div className=" rounded-lg bg-white overflow-hidden shadow-lg">
            <img src={NumericalExample} alt="Numerical mode screenshot" className="w-full h-48 object-cover" />
            <div className="p-6  ">
              <h3 className="text-lg font-bold mb-2">Numerical</h3>
              <p className="text-sm mb-2 font-semibold">Text blocks with their positions preserved.</p>
              <p className="text-sm ">Best for tables, KPIs, or numbers that change frame-to-frame.</p>
            </div>
          </div>

          {/* Region */}
          <div
            onClick={() => navigate('/blog/caption-extraction')}
            className="cursor-pointer rounded-lg bg-white overflow-hidden shadow-lg transform transition-transform duration-200 hover:scale-105"
          >
            <img
              src={RegionExample}
              alt="Region mode screenshot"
              className="w-full h-48 object-cover"
            />
            <div className="p-6">
              <h3 className="text-lg font-bold mb-2">Region</h3>
              <p className="text-sm mb-2 font-semibold">
                Focus only on text inside a defined box.
              </p>
              <p className="text-sm">
                Best for subtitles or fixed-area captions with export by timestamp.
              </p>
            </div>
          </div>
          {/* Scroll */}
          <div
            onClick={() => navigate('/blog/scroll-list-extraction')}
            className="cursor-pointer rounded-lg bg-white overflow-hidden shadow-lg transform transition-transform duration-200 hover:scale-105"
          >
            <img
              src={ScrollListExample}
              alt="Region mode screenshot"
              className="w-full h-48 object-cover"
            />
            <div className="p-6">
              <h3 className="text-lg font-bold mb-2">Scroll</h3>
              <p className="text-sm mb-2 font-semibold">
                Extract data from videos of scrolled lists.
              </p>
              <p className="text-sm">
                Define an item template, then automatically detect all matching patterns throughout your video.
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="divider"></div>
      <div className="container mx-auto px-4">
        <p className="text-2xl font-bold text-center pb-4">Features</p>
  <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 p-6 justify-items-center bg-base-200 rounded-lg">
    {/* Feature 1 */}
    <div className="border bg-base-100 text-center p-8 max-w-xs rounded-lg">
        <CircleStackIcon className="w-12 h-12 inline-block ml-1" />
      <h3 className="text-lg font-semibold">On-Screen Data from Videos</h3>
      <p className="text-sm">Automatically analyze and extract numerical data displayed in videos.</p>
    </div>
        {/* Feature 1 */}
    <div className="border bg-base-100 text-center p-8 max-w-xs rounded-lg">
      <ChatBubbleBottomCenterIcon className="w-12 h-12 inline-block ml-1" />
      <h3 className="text-lg font-semibold">Video Caption Collection</h3>
      <p className="text-sm">Retrieve captions directly from video frames.</p>
    </div>
    {/* Feature 2 */}
    <div className="border bg-base-100 text-center p-8 max-w-xs rounded-lg">
        <PlayCircle className="w-12 h-12 inline-block ml-1" />
      <h3 className="text-lg font-semibold">YouTube Link Import (coming soon)</h3>
      <p className="text-sm">Extract text from YouTube videos with just the link.</p>
    </div>
    {/* Feature 3 */}
    <div className="border bg-base-100 text-center p-8 max-w-xs rounded-lg">
      <PresentationChartLineIcon className="w-12 h-12 inline-block ml-1" />
      <h3 className="text-lg font-semibold">Slide Text from Presentation Recording</h3>
      <p className="text-sm">Capture text from slideshows in videos to efficiently gather information without manual transcription.</p>
    </div>
    {/* Feature 4 */}
    <div className=" border bg-base-100 text-center p-8 max-w-xs rounded-lg">
      <TableCellsIcon className="w-12 h-12 inline-block ml-1" />
      <h3 className="text-lg font-semibold">Spreadsheet Export</h3>
      <p className="text-sm">Export extracted data into CSV format, making it easy to integrate with other data analysis tools.</p>
    </div>
    {/* Feature 5 */}
    {/* <div className="hidden md:block border bg-base-100 text-center p-8 max-w-xs rounded-lg">
      <LanguageIcon className="w-12 h-12 inline-block ml-1" />
      <h3 className="text-lg font-semibold">Translate Captions</h3>
      <p className="text-sm">Easily translate extracted captions into multiple languages, enhancing accessibility and understanding.</p>
    </div> */}
    {/* Feature 6 */}
    <div className="hidden md:block border bg-base-100 text-center p-8 max-w-xs rounded-lg">
    <DocumentChartBarIcon className="w-12 h-12 inline-block ml-1" />
    <h3 className="text-lg font-semibold">Data Series Cleaning</h3>
    <p className="text-sm">Easily clean up extracted data to hone in on the exact data of interest before exporting.</p>
    </div>
  </div>
  <div className="divider"></div>

  
    <div className="items-center flex flex-col w-full gap-2">
          <p className="text-lg text-center">See our blog for examples and use cases.</p>
          <button className="btn btn-normal text-lg" onClick={()=>navigate('/blog')}>Blog</button>
    </div>
</div>

      {/* <div className="flex flex-col lg:flex-row justify-center min-h-1/2 items-center lg:px-8">
        <div className="flex-1 text-center p-4">
            <p className="text-2xl">Multiple Applications</p>
            <div className="flex justify-center items-center text-center tooltip" data-tip="ZestyRides Pro Feature"></div>
            <div className="flex flex-col items-center justify-center">
                <p className="text-md font-bold">Extract data trapped in videos of various content types.</p>
                <ul className="text-left list-disc list-inside mx-auto text-md pt-4">
                    <li>Save numerical data to spreadsheets.</li>
                    <li>Extract and translate captions.</li>
                    <li>Convert slideshow videos to text.</li>
                </ul>
            </div>
        </div>  
      </div>
      <div className="divider"></div>
      <div className="flex flex-col lg:flex-row justify-center min-h-1/2 items-center lg:px-8">
        <div className="flex-1 text-center p-4">
            <p className="text-2xl">Experience Seamless Media Conversion</p>
            <div className="flex justify-center items-center text-center tooltip" data-tip="ZestyRides Pro Feature"></div>
            <div className="flex flex-col items-center justify-center">
                <p className="text-md font-bold">Effortlessly extract and analyze data, automate workflows, and gain insights like never before.</p>
                <ul className="text-left list-disc list-inside mx-auto text-md pt-4">
                    <li>Transform numerical displays and on-screen overlays into editable spreadsheets.</li>
                    <li>Convert presentation recordings into searchable text documents.</li>
                    <li>Accelerate data analysis and content repurposing with advanced automation.</li>
                </ul>
            </div>
        </div>  
      </div> */}
      {/* <div className="divider"></div> */}
      {/* <div className="flex flex-col gap-4">
        <p className="text-lg text-center font-bold">Keep up with Textractify</p>
        <p className="text-md text-center">Enter your email to stay up to date with our launch.</p>
        <div className="flex flex-row gap-4">
          <input
            type="email"
            className="input input-bordered px-4"
            placeholder="Your email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
          <button className="btn btn-success" onClick={handleEmailSubmit}>Submit</button>
        </div>
      </div> */}
      <div className="divider"></div>
<div className="container mx-auto px-4">
  <h2 className="text-2xl font-bold text-center mb-6">Choose from multiple processing engines</h2>
  <p className="text-md text-center pb-8 opacity-80">
    Textractify gives you flexibility in how your videos and images are processed. 
    Depending on your needs, you can prioritize speed, quality, or privacy.
  </p>

  <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
    {/* Local OCR */}
    <div className="bg-base-100 border p-6 rounded-lg text-center">
      <h3 className="text-lg font-semibold mb-2">Local Basic OCR</h3>
      <div className="stats shadow">
        <div className="stat">
          <div className="stat-title">Frames per credit</div>
          <div className="stat-value">{1/CREDIT_VALUE["local"]}</div>
          {/* <div className="stat-desc">21% more than last month</div> */}
        </div>
      </div>
      <p className="text-sm my-4">
        Process directly on your own machine. Fast and private — no internet required.
      </p>
      <ul className="list-disc list-inside text-left text-sm space-y-1">
        <li>Quick setup, lightweight performance</li>
        <li>Best for offline or secure environments</li>
        <li>Lower accuracy for complex handwriting</li>
      </ul>
    </div>

    {/* Server OCR */}
    <div className="bg-base-100 border p-6 rounded-lg text-center">
      <h3 className="text-lg font-semibold mb-2">Basic OCR</h3>
        <div className="stats shadow">
        <div className="stat">
          <div className="stat-title">Frames per credit</div>
          <div className="stat-value">{1/CREDIT_VALUE["server"]}</div>
          {/* <div className="stat-desc">21% more than last month</div> */}
        </div>
      </div>
      <p className="text-sm my-4">
        Your files are processed on our servers with Tesseract OCR — a balance between 
        speed, cost, and accuracy.
      </p>
      <ul className="list-disc list-inside text-left text-sm space-y-1">
        <li>Reliable open-source engine</li>
        <li>Faster turnaround than cloud AI</li>
        <li>Good fit for structured text (slides, tables)</li>
      </ul>
    </div>

        {/* Cloud OCR */}
    <div className="bg-base-100 border p-6 rounded-lg text-center">
      <h3 className="text-lg font-semibold mb-2">Cloud AI OCR</h3>
      <div className="stats shadow">
        <div className="stat">
          <div className="stat-title">Frame per credit</div>
          <div className="stat-value">{1/CREDIT_VALUE["cloud"]}</div>
          {/* <div className="stat-desc">21% more than last month</div> */}
        </div>
      </div>

      <p className="text-sm my-4">
        Tap into AI-powered processing in the cloud for higher accuracy and more advanced features.
      </p>
      <ul className="list-disc list-inside text-left text-sm space-y-1">
        <li>Handles handwritten and messy text</li>
        <li>Great for bulk or large-scale uploads</li>
        <li>Best quality, but requires internet</li>
      </ul>
    </div>
  </div>
</div>

      <div className="divider"></div>
<div className="container mx-auto px-4">
  <h2 className="text-2xl font-bold text-center mb-4">Simple and Transparent Pricing</h2>
    <p className="text-lg text-center pb-4">Pay as you go with credits to process your media. Each frame analyzed consumes one credit, giving you full control over your usage.</p>
  <div className="flex flex-col md:flex-row bg-base-200 p-6 rounded-lg shadow-md gap-8">
    <div className=" p-4 bg-base-100 rounded-lg">
      <h3 className="text-xl font-semibold pb-4">Get Free Credits at Signup</h3>
      <p>New users receive <strong>20 free credits</strong> to test the capabilities of Textractify. Try processing your videos and presentations without any initial cost.</p>
    </div>
    <div className=" p-4 bg-base-100 rounded-lg">
      <h3 className="text-xl font-semibold pb-4">Need More Credits?</h3>
      <p>Purchase additional credits at any time directly through the platform. Choose from flexible packages that fit your needs and scale with your usage. Starting at $1 for 100 credits.</p>
      {/* <button className="btn btn-primary mt-4">Buy Credits</button> */}
    </div>
  </div>
</div>

     
    {user ? 
      <div className="flex flex-col justify-center items-center">
        <DashboardButton/>
      </div> : 
      <div className="flex flex-col justify-center items-center">
        <p className="text-center text-2xl font-bold pb-4">Start Textracting</p>
        <LogInButton/>
      </div>}
    </div>
    )
  ;
}

export default HomePage;